import ApplicationController from './application_controller'

export default class extends ApplicationController {

	static targets = [
		'input',
	]

	static values = {
		basePath: String,
	}

	updateFrame(_event) {
		//console.log(`visiting path: ${this.getPath()}`)
		this.element.src = this.getPath()
	}

	getPath() {
		const inputParams = this.inputTargets
			.map(inputTarget => ({name: inputTarget.name, value: this.getInputValue(inputTarget)}))
			.filter(inputParam => inputParam !== null && inputParam.name && inputParam.value)

		const paramString = inputParams
			.map(inputParam => `${inputParam.name}=${inputParam.value}`)
			.join('&')

		return `${this.basePathValue}?${paramString}`
	}

	getInputValue(inputElement) {
		if (inputElement.disabled) { return null }

		let value = null
		if (inputElement.type === 'radio' || inputElement.type === 'checkbox') {
			if (inputElement.checked) {
				value = inputElement.value
			} else {
				value = null
			}
		} else {
			value = inputElement.value
		}

		return value
	}

}
